import { render } from "./kelompokUnggulan.vue?vue&type=template&id=bb31b134"
import script from "./kelompokUnggulan.vue?vue&type=script&lang=js"
export * from "./kelompokUnggulan.vue?vue&type=script&lang=js"

import "./kelompokUnggulan.vue?vue&type=style&index=0&id=bb31b134&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__